import React from 'react';
import { Table, Button } from '../../common';

interface SubAdminConsentTableRowProps {
	displayName: string;
	type: string;
	onGrantAdminConsent: any;
}

const SubAdminConsentTableRow = ({ displayName, type, onGrantAdminConsent }: SubAdminConsentTableRowProps) => {
	const handleConsent = () => {
		onGrantAdminConsent();
	};
	return (
		<Table.Row>
			<Table.Cell>
				<div>{displayName}</div>
			</Table.Cell>
			<Table.Cell>
				<div>{type}</div>
			</Table.Cell>
			<Table.Cell>
				<Button onClick={handleConsent}>Grant Admin Consent</Button>
			</Table.Cell>
		</Table.Row>
	);
};

export default SubAdminConsentTableRow;
